module.exports = __webpack_public_path__ + "static/img/img3.875fc0f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/img3.png
// module id = rgWj
// module chunks = 1